import { CreateStore, createStore } from '@packages/stores';
import { ApiState, BoostDetails, EmcDeclaring } from '@packages/types';

import { fetchBoostDetailsById } from './boost.api';

export interface BoostDetailsState {
  boostDetails: BoostDetails | undefined;
  mandatoryBoostDetails: BoostDetails | undefined;
  boostDetailsApiState: Record<string, ApiState>;
  error: Error | undefined;
  emcDeclaring: EmcDeclaring | null;
}

export interface BoostDetailsActions {
  getBoostDetails: (boostId: string) => Promise<BoostDetails | undefined>;
  setBoostDetails: (boostDetails?: BoostDetails) => void;
  setError: (error: Error) => void;
  setEmcDeclaring: (data: EmcDeclaring) => void;
  setBoostDetailsApiState: (boostId: string, apiState: ApiState) => void;
  clearMandatoryBoostDetails: () => void;
}

export type BoostDetailsStore = BoostDetailsState & BoostDetailsActions;

export const boostDetailsInitialState: BoostDetailsState = {
  error: undefined,
  boostDetails: undefined,
  mandatoryBoostDetails: undefined,
  emcDeclaring: null,
  boostDetailsApiState: {},
};

export const boostDetailsStore: CreateStore<BoostDetailsStore> = (set, get) => ({
  ...boostDetailsInitialState,
  getBoostDetails: async boostId => await fetchBoostDetailsById(get, boostId),
  setBoostDetails: boostDetails => {
    set(state => {
      if (boostDetails?.isMandatory) {
        state.mandatoryBoostDetails = boostDetails;
      }
      state.boostDetails = boostDetails;
    });
  },
  setEmcDeclaring: data => {
    set(state => {
      state.emcDeclaring = data;
    });
  },
  setError: error => {
    set(state => {
      state.error = error;
    });
  },
  setBoostDetailsApiState: (boostId, apiState) => {
    set(state => {
      state.boostDetailsApiState[boostId] = apiState;
    });
  },
  clearMandatoryBoostDetails: () => {
    set(state => {
      state.mandatoryBoostDetails = undefined;
    });
  },
});

export const useBoostDetailsStore = createStore(boostDetailsStore, {
  name: 'useBoostDetailsStore',
});
